import { useRef, useState } from "react";
import { toast } from "sonner";
import { api } from "./api";

// Téléversement de logo client (personnalisation) — partagé entre la fiche produit
// et la fiche rapide (popup) de la boutique.
export function useLogoUpload(t) {
  const [logo, setLogo] = useState(null);   // {path, name, url}
  const [uploading, setUploading] = useState(false);
  const fileInput = useRef(null);

  const uploadLogo = async (e, onDone) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      toast.error(t("product.logo_formats"));
      return;
    }
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/uploads/logo", form);
      setLogo(data);
      toast.success(t("product.logo_uploaded"));
      onDone?.(data);
    } catch (err) {
      toast.error(err.response?.data?.detail || t("product.logo_formats"));
    } finally {
      setUploading(false);
      if (fileInput.current) fileInput.current.value = "";
    }
  };

  return { logo, setLogo, uploading, fileInput, uploadLogo };
}
